// extracted by mini-css-extract-plugin
export default {"bellContainer":"BellIcon_bellContainer__-g3M9","circle":"BellIcon_circle__SLEwm","bellWrapper":"BellIcon_bellWrapper__6Mgw6","bell":"BellIcon_bell__rmN2K"};